module.exports = __webpack_public_path__ + "static/images/containers/MainMenu/images/mainmenu-item-active-highlight.a25a874e.png";


//////////////////
// WEBPACK FOOTER
// ./containers/MainMenu/images/mainmenu-item-active-highlight.png
// module id = 3176
// module chunks = 11